<template>
    <div>
        <b-card-code
                title="Szerkesztés"
        >
            <b-overlay
                    :show="loading"
                    spinner-variant="primary"
                    spinner-type="grow"
                    rounded="sm"
            >
                <!-- form -->
                <validation-observer ref="simpleRules">
                    <b-form>
                        <b-row>
                            <b-col md="4">
                                <b-form-group
                                        label="Halkategória"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="halkategória"
                                            rules="required"
                                            vid="fishCategory"
                                    >
                                        <b-overlay
                                                :show="selectLoading"
                                                spinner-variant="primary"
                                                spinner-type="grow"
                                                rounded="sm"
                                        >
                                            <v-select
                                                    v-model="formData.fishCategory"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    label="title"
                                                    :options="fishCategoryOptions"
                                            >
                                                <template #no-options>
                                                    <span style="">Sajnáljuk, nincs egyező találat.</span>
                                                </template>
                                            </v-select>
                                        </b-overlay>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group
                                        label="Név"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="név"
                                            rules="required"
                                            vid="name"
                                    >
                                        <b-form-input
                                                v-model="formData.name"
                                                :state="errors.length > 0 ? false:null"
                                                placeholder="név"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group
                                        label="Szín"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="szín"
                                            rules="required"
                                            vid="color"
                                    >
                                        <b-form-input
                                                type="color"
                                                v-model="formData.color"
                                                :state="errors.length > 0 ? false:null"
                                                placeholder="szín"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="6">
                                <b-form-group
                                        label="Minimum tömeg"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="minimum tömeg"
                                            rules=""
                                            vid="minWeight"
                                    >
                                        <b-input-group>
                                            <b-form-input
                                                    v-model="formData.minWeight"
                                                    type="number"
                                                    lang="hu"
                                                    :state="errors.length > 0 ? false:null"
                                                    :step="0.01"
                                                    :min="0"
                                            />
                                            <b-input-group-append>
                                                <b-input-group-text>kg</b-input-group-text>
                                            </b-input-group-append>
                                        </b-input-group>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="6">
                                <b-form-group
                                        label="Maximum tömeg"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="maximum tömeg"
                                            rules=""
                                            vid="maxWeight"
                                    >
                                        <b-input-group>
                                            <b-form-input
                                                    v-model="formData.maxWeight"
                                                    type="number"
                                                    lang="hu"
                                                    :state="errors.length > 0 ? false:null"
                                                    :step="0.01"
                                                    :min="0"
                                            />
                                            <b-input-group-append>
                                                <b-input-group-text>kg</b-input-group-text>
                                            </b-input-group-append>
                                        </b-input-group>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="6">
                                <b-form-group
                                        label="Minimum hossz"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="minimum hossz"
                                            rules=""
                                            vid="minLength"
                                    >
                                        <b-input-group>
                                            <b-form-input
                                                    v-model="formData.minLength"
                                                    type="number"
                                                    lang="hu"
                                                    :state="errors.length > 0 ? false:null"
                                                    :min="0"
                                            />
                                            <b-input-group-append>
                                                <b-input-group-text>cm</b-input-group-text>
                                            </b-input-group-append>
                                        </b-input-group>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="6">
                                <b-form-group
                                        label="Maximum hossz"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="maximum hossz"
                                            rules=""
                                            vid="maxLength"
                                    >
                                        <b-input-group>
                                            <b-form-input
                                                    v-model="formData.maxLength"
                                                    type="number"
                                                    lang="hu"
                                                    :state="errors.length > 0 ? false:null"
                                                    :min="0"
                                            />
                                            <b-input-group-append>
                                                <b-input-group-text>cm</b-input-group-text>
                                            </b-input-group-append>
                                        </b-input-group>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="6">
                                <b-form-group
                                        label="Minimum kerület"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="minimum kerület"
                                            rules=""
                                            vid="minPerimeter"
                                    >
                                        <b-input-group>
                                            <b-form-input
                                                    v-model="formData.minPerimeter"
                                                    type="number"
                                                    lang="hu"
                                                    :state="errors.length > 0 ? false:null"
                                                    :min="0"
                                            />
                                            <b-input-group-append>
                                                <b-input-group-text>cm</b-input-group-text>
                                            </b-input-group-append>
                                        </b-input-group>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="6">
                                <b-form-group
                                        label="Maximum kerület"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="maximum kerület"
                                            rules=""
                                            vid="maxPerimeter"
                                    >
                                        <b-input-group>
                                            <b-form-input
                                                    v-model="formData.maxPerimeter"
                                                    type="number"
                                                    lang="hu"
                                                    :state="errors.length > 0 ? false:null"
                                                    :min="0"
                                            />
                                            <b-input-group-append>
                                                <b-input-group-text>cm</b-input-group-text>
                                            </b-input-group-append>
                                        </b-input-group>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <!-- submit button -->
                            <b-col class="mt-1">
                                <b-button
                                        variant="primary"
                                        type="submit"
                                        class="float-right"
                                        @click.prevent="submitForm"
                                >
                                    Mentés
                                </b-button>
                                <cancel-and-g-o-t-o-previous-page class="mr-2"/>
                            </b-col>
                        </b-row>
                    </b-form>
                </validation-observer>
            </b-overlay>
        </b-card-code>
        <b-card-code>
            <tabs
                    ref="tabs"
                    :entity-id="parseInt(this.$route.params.id)"
            />
        </b-card-code>
    </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    BOverlay,
    BInputGroupText,
    BInputGroupAppend,
    BInputGroup,
} from 'bootstrap-vue'
import {
    required,
} from '@validations'
import vSelect from 'vue-select'
import tabs from '@/views/pages/_components/_tabs/_fishType/update.vue'
import cancelAndGOTOPreviousPage from '@/views/pages/_components/_helper/cancelAndGOTOPreviousPage'
import {formatFloatToComma} from "@/libs/formatter/numberFormatter"

export default {
    components: {
        BInputGroup, BInputGroupAppend, BInputGroupText,
        BCardCode,
        ValidationProvider,
        ValidationObserver,
        BFormInput,
        BFormGroup,
        BForm,
        BRow,
        BCol,
        BButton,
        BFormCheckbox,
        BOverlay,
        vSelect,
        tabs,
        cancelAndGOTOPreviousPage,
    },
    data() {
        return {
            role: 'fish_type',
            loading: false,
            selectLoading: false,
            formData: {
                id: null,
                name: '',
                color: '',
                fishCategory: '',
                minWeight: '',
                maxWeight: '',
                minLength: '',
                maxLength: '',
                minPerimeter: '',
                maxPerimeter: '',
            },
            fishCategoryOptions: [],
            required,
            formatFloatToComma,
        }
    },
    created() {
        this.loading = true

        this.$store.dispatch('fetchFishType', this.$route.params.id).then(response => {
            this.formData = response.data.entity
            this.formData.id = this.$route.params.id
            this.formData.minWeight = parseFloat(response.data.entity.min_weight)
            this.formData.maxWeight = parseFloat(response.data.entity.max_weight)
            this.formData.minLength = parseInt(response.data.entity.min_length)
            this.formData.maxLength = parseInt(response.data.entity.max_length)
            this.formData.minPerimeter = parseInt(response.data.entity.min_perimeter)
            this.formData.maxPerimeter = parseInt(response.data.entity.max_perimeter)

            this.selectLoading = true
            this.$store.dispatch('fetchFishCategoriesForSelect').then(fcResponse => {
                this.fishCategoryOptions = fcResponse

                if (this.fishCategoryOptions.length) {
                    Object.keys(fcResponse).forEach(key => {
                        if (fcResponse[key].value === parseInt(response.data.entity.fish_category_id)) {
                            this.formData.fishCategory = fcResponse[key]
                        }
                    })
                }
            }).finally(() => {
                this.selectLoading = false
            })
        }).finally(() => {
            this.loading = false
        })
    },
    methods: {
        submitForm() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.loading = true

                    let fd = {...this.formData}
                    fd.fishCategory = this.formData.fishCategory.value

                    this.$store.dispatch('updateFishType', fd).then(() => {
                        this.$refs.tabs.refreshLog()
                        this.$helpers.showSuccessToast('Halfaj módosítva.')

                        this.$acl.canListPermission(this.role)
                            ? this.$router.push({name: 'fish-types'})
                            : this.$router.go(-1)
                    }).catch(error => {
                        if (error.response.status === 422) {
                            this.$refs.simpleRules.setErrors(error.response.data.errors)
                        } else {
                            this.$helpers.showErrorToast(error.toString())
                        }
                    }).finally(() => {
                        this.loading = false
                    })
                }
            })
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
